/* tslint:disable */
/* eslint-disable */
/**
 * Ак Барс Недвижимость API
 * Инструменты разработчика:  [ [Документация API. Swagger](/docs/) ]  [ [Документация API. Redoc](/redoc/) ] [ [Панель администрирования](/admin/) ] [ [Документация Image-Service](/api/attachments/docs/) ]
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserDevice
 */
export interface UserDevice {
    /**
     * 
     * @type {string}
     * @memberof UserDevice
     */
    name?: string | null;
    /**
     * Inactive devices will not be sent notifications
     * @type {boolean}
     * @memberof UserDevice
     */
    active?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserDevice
     */
    registrationId: string;
    /**
     * 
     * @type {Date}
     * @memberof UserDevice
     */
    readonly createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof UserDevice
     */
    readonly updatedAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof UserDevice
     */
    readonly lastSeenAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof UserDevice
     */
    type?: UserDeviceTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof UserDevice
     */
    readonly deviceId?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDevice
     */
    appVersion?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserDevice
     */
    osVersion?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserDevice
     */
    model?: string | null;
}

export function UserDeviceFromJSON(json: any): UserDevice {
    return UserDeviceFromJSONTyped(json, false);
}

export function UserDeviceFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserDevice {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'active': !exists(json, 'active') ? undefined : json['active'],
        'registrationId': json['registrationId'],
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (new Date(json['updatedAt'])),
        'lastSeenAt': !exists(json, 'lastSeenAt') ? undefined : (new Date(json['lastSeenAt'])),
        'type': !exists(json, 'type') ? undefined : json['type'],
        'deviceId': !exists(json, 'deviceId') ? undefined : json['deviceId'],
        'appVersion': !exists(json, 'appVersion') ? undefined : json['appVersion'],
        'osVersion': !exists(json, 'osVersion') ? undefined : json['osVersion'],
        'model': !exists(json, 'model') ? undefined : json['model'],
    };
}

export function UserDeviceToJSON(value?: UserDevice | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'active': value.active,
        'registrationId': value.registrationId,
        'type': value.type,
        'appVersion': value.appVersion,
        'osVersion': value.osVersion,
        'model': value.model,
    };
}

/**
* @export
* @enum {string}
*/
export enum UserDeviceTypeEnum {
    Android = 'android',
    Ios = 'ios',
    Web = 'web',
    Unknown = 'unknown'
}


